module.exports = __webpack_public_path__ + "m-wxShareBox-clear-6772f844.png";